/**
 * The package names as a customer reads them — one place for every surface
 * that names a plan (the «what's new» pop-up, the tier lock in the menu and
 * on the screen). The key is the catalog's `ProductPackageKey`; the name is
 * the brand name, the same in every locale.
 */
import {
  findTierFeatureGate,
  type FeatureFlagKey,
  type ProductPackageKey,
} from '@aica/core';

export const PACKAGE_LABEL: Record<ProductPackageKey, string> = {
  free: 'Free',
  starter: 'Starter',
  pro: 'Pro',
  business: 'Business',
  scale: 'Scale',
  enterprise: 'Enterprise',
};

/**
 * The plan a feature is sold from, by its flag — read from the catalog gate
 * (`findTierFeatureGate(flag).minTier`), never written next to the flag key.
 * `null` for a flag that is not sold from a tier up.
 */
export function minPlanLabel(flag: FeatureFlagKey): string | null {
  const gate = findTierFeatureGate(flag);
  return gate ? PACKAGE_LABEL[gate.minTier] : null;
}
